import React from 'react'
import styled from 'styled-components'
import DropdownMenu from '../../header/dropdown-menu'
import ShapesImage from '../../../images/shapes/footer.svg'
import Shapes from '../shapes'

const Section = styled.section`
    position: relative;
`

const ShapesFooter = styled(Shapes)`
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);

    &:before {
        background-size: cover;
    }
`

const Footer = () => (
    <Section>
        <ShapesFooter source={ShapesImage} />
        <DropdownMenu isFooter />
    </Section>
)

export default Footer
